module.exports = __webpack_public_path__ + "static/media/27.fc4aefa5.jpg";